import React from 'react';
import { useTranslate } from 'react-admin';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { useStyles } from '~/hooks/useLayoutMenuStyles';
import { l } from '~/types/layoutMenu';

// 'sidebar': expanded sidebar, plain accordion row.
// 'rail': collapsed sidebar, vertical icon-over-label tile that triggers a hover flyout.
// 'flyout': rendered inside another group's rail flyout popover.
type GroupHeaderVariant = 'sidebar' | 'rail' | 'flyout';

type GroupHeaderProps = {
  labelKey: string;
  shortLabelKey?: string; // only used in the 'rail' variant; has no effect otherwise
  icon: JSX.Element;
  isOpen: boolean;
  isActive: boolean;
  variant: GroupHeaderVariant;
  onToggle: () => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: () => void;
};

const GroupHeader = ({
  labelKey,
  shortLabelKey,
  icon,
  isOpen,
  isActive,
  variant,
  onToggle,
  onMouseEnter,
  onMouseLeave,
}: GroupHeaderProps) => {
  const translate = useTranslate();
  const t = (key: string, options?: any): string => translate(l(key), options);
  const classes = useStyles({});
  const isRail = variant === 'rail';
  return (
    <ListItem
      button
      onMouseEnter={isRail ? (onMouseEnter as any) : undefined}
      onMouseLeave={isRail ? onMouseLeave : undefined}
      onClick={!isRail ? onToggle : undefined}
      className={
        {
          rail: `${classes.railItem} ${isActive ? classes.railGroupActive : ''}`,
          flyout: `${classes.flyoutItem} ${isActive ? classes.flyoutHeaderActive : ''}`,
          sidebar: `${classes.groupHeader} ${isActive ? classes.groupHeaderActive : ''}`,
        }[variant]
      }
    >
      <ListItemIcon
        className={
          { rail: classes.railIcon, flyout: classes.flyoutIcon, sidebar: undefined }[variant]
        }
      >
        {icon}
      </ListItemIcon>
      {isRail ? (
        <span className={classes.railLabel}>{t(shortLabelKey || labelKey)}</span>
      ) : (
        <ListItemText primary={t(labelKey)} primaryTypographyProps={{ noWrap: true }} />
      )}
      {!isRail &&
        (isOpen ? (
          <ExpandLess className={classes.expandIcon} />
        ) : (
          <ExpandMore className={classes.expandIcon} />
        ))}
    </ListItem>
  );
};

export default GroupHeader;
